"use client"

import { Tab, Tabs } from "@heroui/react"

export default function PageClient() {
  const handleClick = () => {
    window.open("https://snaptheprice.com/", "_blank")
  }
  return (
    <div>
      <div className="flex h-[47px] w-full items-center justify-center bg-[#0F9E4F] text-[24px] font-bold text-white sm:h-[120px] sm:text-[36px]">
        How to use SnapThePrice?
      </div>
      <div className="w-full pt-4 sm:hidden">
        <Tabs
          aria-label="Dynamic tabs"
          classNames={{
            tabList: "w-full h-[33px] ml-2 rounded-full",
            tab: "text-black h-[33px] w-[171px] group-data-[selected=true]:!text-[#fff] rounded-full text-[14px] font-medium",
            tabContent:
              "text-black group-data-[selected=true]:!text-[#fff] text-[14px] font-medium",
            cursor: "!rounded-full bg-[#0F9E4F] rounded-full",
          }}
        >
          <Tab key={"extension"} title={"Extension"}>
            <div className="justify-center gap-[56px] px-3 pt-4 sm:flex sm:px-[56px] sm:pt-[32px]">
              <div className="sm:w-[48%]">
                <div className="text-[26px] font-bold text-[#0F9E4F] italic">
                  Method 1
                </div>
                <div className="text-[20px] font-bold text-[#1D2129]">
                  How to Snap the Lowest Price on E-commerce Platforms and Brand
                  Websites
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  Welcome to the SnapThePrice tutorial! In this guide, we’ll
                  walk you step by step through how to use the SnapThePrice
                  extension to quickly find the lowest price for any product.
                  Whether you’re shopping on e-commerce platforms like Amazon,
                  BestBuy, Walmart, or browsing brand websites like Nike or
                  Apple, SnapThePrice helps you save both time and money. Let’s
                  get started!
                </div>
                <video
                  src="/video/extensionuse.mp4"
                  autoPlay
                  // muted
                  loop
                  controls
                  style={{ width: "100%", borderRadius: "8px" }}
                />
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    1
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Install the SnapThePrice Extension
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  Before you can enjoy the power of SnapThePrice, you’ll need to
                  install the extension in your browser. Here’s how:
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  1. Open your Chrome browser.
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  2. Go to the Chrome Web Store.
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  3. Search for “SnapThePrice” and click “Add to Chrome.”
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  4. Once installed, you’ll see the SnapThePrice green icon in
                  your browser toolbar.
                </div>
                <div className="mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    2
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Browse E-commerce Platforms or Brand Websites
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  Next, open your favorite online shopping site or brand store.
                  For example:
                </div>
                <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
                  <li className="mb-2">
                    Amazon: Books, electronics, home essentials, and more.
                  </li>
                  <li className="mb-2">
                    BestBuy: TVs, smartphones, appliances, etc.
                  </li>
                  <li className="mb-2">Walmart: Everyday products at scale.</li>
                  <li className="mb-2">
                    Nike or Apple: The latest sneakers or tech devices.
                  </li>
                </ul>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  or many other e-commerce platforms, simply go to the product
                  detail page you’re interested in. 
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  SnapThePrice supports many other e-commerce sites, so you can
                  use it to compare prices from a wide range of online
                  retailers.
                </div>
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    3
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Use SnapThePrice to Compare Prices
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  When you’re browsing a product page, using SnapThePrice is
                  easy:
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  1. Click the green button: Next to the product price, you’ll
                  see a green SnapThePrice button. Click it to launch the
                  comparison feature.
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  2. Automatic scanning: SnapThePrice instantly searches across
                  the web for the same product, scanning multiple platforms and
                  brand websites in real time.
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  3. View the lowest offers: The results will appear in the
                  extension’s panel on the right side of your screen, showing
                  you the lowest available price along with other relevant
                  offers.
                </div>
                <div className="mb-2 text-[14px] font-bold text-[#1D2129]">
                  What if the green button doesn’t appear?
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  Sometimes, on certain websites or product pages, the green
                  SnapThePrice button might not show up. No worries—you can
                  still run a price check easily:
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  1. Pin the extension: First, make sure SnapThePrice is pinned
                  to your browser’s toolbar. Right-click the extension and
                  select “Pin.” The icon will then always be visible in the
                  top-right corner of your browser.
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  2. Click the SnapThePrice icon: If you don’t see the green
                  button near the product price, simply click the SnapThePrice
                  icon in your browser toolbar. The extension will start
                  scanning the product immediately.
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  3. Check the results: The panel on the right will display the
                  lowest price offers found online. You can then compare options
                  and choose the best deal.
                </div>
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    4
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Compare and Choose
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  SnapThePrice lists results from lowest to highest, helping you
                  quickly identify the best deal.
                </div>
                <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
                  <li className="mb-2">
                    Pick the lowest price: Click the offer you want, and
                    SnapThePrice will redirect you straight to that store’s
                    product page.
                  </li>
                  <li className="mb-5">
                    Complete your purchase: Finalize checkout directly on the
                    retailer’s website and enjoy your savings.
                  </li>
                </ul>
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    5
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Enhance Your Shopping Experience
                  </div>
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  Beyond price comparison, SnapThePrice keeps you updated with
                  real-time market prices whenever you shop. It saves you from
                  manually checking multiple sites and ensures you always buy at
                  the best available rate.
                </div>
                <div className="mb-2 text-[20px] font-bold text-[#1D2129]">
                  Conclusion
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  With these steps, you can easily use SnapThePrice across major
                  e-commerce platforms and brand websites. Whether it’s Amazon,
                  BestBuy, Walmart, Nike, or Apple, SnapThePrice helps you
                  uncover the lowest price every time—making your shopping
                  smarter and more affordable. Download and install SnapThePrice
                  today, and start enjoying smarter shopping! 🚀
                </div>
              </div>
            </div>
          </Tab>
          <Tab key={"web"} title={"Web"}>
            <div className="justify-center gap-[56px] px-3 pt-4 sm:flex sm:px-[56px] sm:pt-[32px]">
              <div className="sm:w-[48%]">
                <div className="text-[26px] font-bold text-[#0F9E4F] italic">
                  Method 2
                </div>
                <div className="text-[20px] font-bold text-[#1D2129]">
                  How to Snap the Lowest Price Without the Plugin or on Mobile
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  If you don’t have the SnapThePrice extension installed or
                  prefer to compare prices on your mobile device, you can still
                  find the best deals using the SnapThePrice website. Here’s a
                  step-by-step guide:
                </div>
                <video
                  src="/video/web.mp4"
                  autoPlay
                  // muted
                  loop
                  controls
                  style={{ width: "100%", borderRadius: "8px" }}
                />
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    1
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Copy the Product URL
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  When browsing a product on sites like:
                </div>
                <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
                  <li className="mb-2">Amazon</li>
                  <li className="mb-2">BestBuy</li>
                  <li className="mb-2">Walmart</li>
                  <li className="mb-2">Nike or Apple</li>
                </ul>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  or many other e-commerce platforms, simply go to the product
                  detail page you’re interested in. Then, copy the URL from your
                  browser’s address bar.
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  SnapThePrice supports many other e-commerce sites, so you can
                  use it to compare prices from a wide range of online
                  retailers.
                </div>
                <div className="mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    2
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Paste the URL on SnapThePrice.com
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  1. Open{" "}
                  <span
                    onClick={handleClick}
                    className="cursor-pointer underline"
                  >
                    SnapThePrice.com
                  </span>{" "}
                  on your browser or mobile device.
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  2. Paste the copied product URL into the search box on the
                  homepage.
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  3. Click the “Search” button to start the comparison.
                </div>
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    3
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    View the Lowest Price Offers
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  SnapThePrice will immediately begin scanning the web for the
                  same product and display:
                </div>
                <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
                  <li className="mb-2">
                    The lowest available price across multiple e-commerce
                    platforms and brand websites.
                  </li>
                  <li className="mb-5">
                    Relevant offers, shipping details, and any available
                    promotions.
                  </li>
                </ul>
                <div className="mt-5 mb-2 flex items-center gap-2">
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
                    4
                  </div>
                  <div className="text-[20px] font-bold text-[#1D2129]">
                    Choose the Best Deal
                  </div>
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  From the list of offers, you can:
                </div>
                <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
                  <li className="mb-2">
                    Select the lowest price: Click the link to go directly to
                    that product on the retailer’s website.
                  </li>
                  <li className="mb-5">
                    Complete your purchase: Enjoy the savings while shopping at
                    the best available price.
                  </li>
                </ul>
                <div className="mb-2 text-[20px] font-bold text-[#1D2129]">
                  Summary
                </div>
                <div className="mb-2 text-[14px] text-[#4E5969]">
                  Even without the browser extension, SnapThePrice.com makes it
                  simple to compare prices on any device. Just copy a product
                  link, paste it on the website, and instantly find the lowest
                  price. This is perfect for mobile users or for those who
                  haven’t installed the extension yet.
                </div>
                <div className="mb-5 text-[14px] text-[#4E5969]">
                  Start using SnapThePrice.com today and make sure you never
                  overpay for your favorite products!
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
      <div className="hidden justify-center gap-[56px] px-3 pt-6 sm:flex sm:px-[56px] sm:pt-[32px]">
        <div className="sm:w-[48%]">
          <div className="text-[26px] font-bold text-[#0F9E4F] italic">
            Method 1
          </div>
          <div className="text-[20px] font-bold text-[#1D2129]">
            How to Snap the Lowest Price on E-commerce Platforms and Brand
            Websites
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            Welcome to the SnapThePrice tutorial! In this guide, we’ll walk you
            step by step through how to use the SnapThePrice extension to
            quickly find the lowest price for any product. Whether you’re
            shopping on e-commerce platforms like Amazon, BestBuy, Walmart, or
            browsing brand websites like Nike or Apple, SnapThePrice helps you
            save both time and money. Let’s get started!
          </div>
          <video
            src="/video/extensionuse.mp4"
            autoPlay
            // muted
            loop
            controls
            style={{ width: "100%", borderRadius: "8px" }}
          />
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              1
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Install the SnapThePrice Extension
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            Before you can enjoy the power of SnapThePrice, you’ll need to
            install the extension in your browser. Here’s how:
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            1. Open your Chrome browser.
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            2. Go to the Chrome Web Store.
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            3. Search for “SnapThePrice” and click “Add to Chrome.”
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            4. Once installed, you’ll see the SnapThePrice green icon in your
            browser toolbar.
          </div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              2
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Browse E-commerce Platforms or Brand Websites
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            Next, open your favorite online shopping site or brand store. For
            example:
          </div>
          <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
            <li className="mb-2">
              Amazon: Books, electronics, home essentials, and more.
            </li>
            <li className="mb-2">
              BestBuy: TVs, smartphones, appliances, etc.
            </li>
            <li className="mb-2">Walmart: Everyday products at scale.</li>
            <li className="mb-2">
              Nike or Apple: The latest sneakers or tech devices.
            </li>
          </ul>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            or many other e-commerce platforms, simply go to the product detail
            page you’re interested in. 
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            SnapThePrice supports many other e-commerce sites, so you can use it
            to compare prices from a wide range of online retailers.
          </div>
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              3
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Use SnapThePrice to Compare Prices
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            When you’re browsing a product page, using SnapThePrice is easy:
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            1. Click the green button: Next to the product price, you’ll see a
            green SnapThePrice button. Click it to launch the comparison
            feature.
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            2. Automatic scanning: SnapThePrice instantly searches across the
            web for the same product, scanning multiple platforms and brand
            websites in real time.
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            3. View the lowest offers: The results will appear in the
            extension’s panel on the right side of your screen, showing you the
            lowest available price along with other relevant offers.
          </div>
          <div className="mb-2 text-[14px] font-bold text-[#1D2129]">
            What if the green button doesn’t appear?
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            Sometimes, on certain websites or product pages, the green
            SnapThePrice button might not show up. No worries—you can still run
            a price check easily:
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            1. Pin the extension: First, make sure SnapThePrice is pinned to
            your browser’s toolbar. Right-click the extension and select “Pin.”
            The icon will then always be visible in the top-right corner of your
            browser.
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            2. Click the SnapThePrice icon: If you don’t see the green button
            near the product price, simply click the SnapThePrice icon in your
            browser toolbar. The extension will start scanning the product
            immediately.
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            3. Check the results: The panel on the right will display the lowest
            price offers found online. You can then compare options and choose
            the best deal.
          </div>
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              4
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Compare and Choose
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            SnapThePrice lists results from lowest to highest, helping you
            quickly identify the best deal.
          </div>
          <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
            <li className="mb-2">
              Pick the lowest price: Click the offer you want, and SnapThePrice
              will redirect you straight to that store’s product page.
            </li>
            <li className="mb-5">
              Complete your purchase: Finalize checkout directly on the
              retailer’s website and enjoy your savings.
            </li>
          </ul>
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              5
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Enhance Your Shopping Experience
            </div>
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            Beyond price comparison, SnapThePrice keeps you updated with
            real-time market prices whenever you shop. It saves you from
            manually checking multiple sites and ensures you always buy at the
            best available rate.
          </div>
          <div className="mb-2 text-[20px] font-bold text-[#1D2129]">
            Conclusion
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            With these steps, you can easily use SnapThePrice across major
            e-commerce platforms and brand websites. Whether it’s Amazon,
            BestBuy, Walmart, Nike, or Apple, SnapThePrice helps you uncover the
            lowest price every time—making your shopping smarter and more
            affordable. Download and install SnapThePrice today, and start
            enjoying smarter shopping! 🚀
          </div>
        </div>
        <div className="sm:w-[48%]">
          <div className="text-[26px] font-bold text-[#0F9E4F] italic">
            Method 2
          </div>
          <div className="text-[20px] font-bold text-[#1D2129]">
            How to Snap the Lowest Price Without the Plugin or on Mobile
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            If you don’t have the SnapThePrice extension installed or prefer to
            compare prices on your mobile device, you can still find the best
            deals using the SnapThePrice website. Here’s a step-by-step guide:
          </div>
          <video
            src="/video/web.mp4"
            autoPlay
            // muted
            loop
            controls
            style={{ width: "100%", borderRadius: "8px" }}
          />
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              1
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Copy the Product URL
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            When browsing a product on sites like:
          </div>
          <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
            <li className="mb-2">Amazon</li>
            <li className="mb-2">BestBuy</li>
            <li className="mb-2">Walmart</li>
            <li className="mb-2">Nike or Apple</li>
          </ul>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            or many other e-commerce platforms, simply go to the product detail
            page you’re interested in. Then, copy the URL from your browser’s
            address bar.
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            SnapThePrice supports many other e-commerce sites, so you can use it
            to compare prices from a wide range of online retailers.
          </div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              2
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Paste the URL on SnapThePrice.com
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            1. Open{" "}
            <span onClick={handleClick} className="cursor-pointer underline">
              SnapThePrice.com
            </span>{" "}
            on your browser or mobile device.
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            2. Paste the copied product URL into the search box on the homepage.
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            3. Click the “Search” button to start the comparison.
          </div>
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              3
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              View the Lowest Price Offers
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            SnapThePrice will immediately begin scanning the web for the same
            product and display:
          </div>
          <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
            <li className="mb-2">
              The lowest available price across multiple e-commerce platforms
              and brand websites.
            </li>
            <li className="mb-5">
              Relevant offers, shipping details, and any available promotions.
            </li>
          </ul>
          <div className="mt-5 mb-2 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#0F9E4F] text-white">
              4
            </div>
            <div className="text-[20px] font-bold text-[#1D2129]">
              Choose the Best Deal
            </div>
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            From the list of offers, you can:
          </div>
          <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
            <li className="mb-2">
              Select the lowest price: Click the link to go directly to that
              product on the retailer’s website.
            </li>
            <li className="mb-5">
              Complete your purchase: Enjoy the savings while shopping at the
              best available price.
            </li>
          </ul>
          <div className="mb-2 text-[20px] font-bold text-[#1D2129]">
            Summary
          </div>
          <div className="mb-2 text-[14px] text-[#4E5969]">
            Even without the browser extension, SnapThePrice.com makes it simple
            to compare prices on any device. Just copy a product link, paste it
            on the website, and instantly find the lowest price. This is perfect
            for mobile users or for those who haven’t installed the extension
            yet.
          </div>
          <div className="mb-5 text-[14px] text-[#4E5969]">
            Start using SnapThePrice.com today and make sure you never overpay
            for your favorite products!
          </div>
        </div>
      </div>
    </div>
  )
}
